module.exports = __webpack_public_path__ + "static/FY_2023_Announcement_Financial_Results-1e33635b76db9101cdc865fbcfd68269.pdf";